import React from "react";
import styled from "styled-components";
import { Theme } from "@pga/pga-component-library";
import { path, pathOr } from "ramda";
import HiddenOn from "../../common/components/HiddenOn";
import {
  isValidDeadline,
  getFacilityUrl,
  jobInformationData,
  jobOfficeName,
  isValidPostingStage,
} from "./utils";
import ShowApplyButton from "./ShowApplyButton";
import JobDetailInfoSectionItem from "./JobDetailInfoSectionItem";
import JobDetailInfoSection from "./JobDetailInfoSection";

const SideBarContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`;
const OfficeHeader = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 0px;
`;
const OfficeImage = styled.img`
  margin-right: 20px;
  width: 73px;
  height: 73px;
`;
const OfficeTitle = styled.h2`
  display: inline-block;
  color: ${Theme.colors.primary};
  font-family: ${Theme.fonts.Montserrat};
  font-size: 18px;
  font-weight: 550;
  line-height: 1.5rem;
`;

const SideBarLabel = styled.div`
  color: ${Theme.colors.primary};
  font-family: ${Theme.fonts.Montserrat};
  font-weight: 300;
  font-size: 14px;
  line-height: 28px;
`;

const SideBarTitle = styled(SideBarLabel)`
  color: ${Theme.colors.blueGrey};
  font-size: 12px;
  font-weight: 400;
`;

const SideBarHeader = styled.div`
  margin-top: 20px;
  display: flex;
`;

const SideBarContainer = styled.div`
  width: 100%;
  margin: 20px 0px;
  min-width: 300px;

  @media (min-width: 992px) {
    max-width: 400px;
    margin: 10px auto;
  }
`;

const SideBarHeaderWrapper = styled.div`
  margin-right: auto;
`;

const CardContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  background-color: ${Theme.colors.white};
  box-shadow: 0 5px 10px 0 ${Theme.colors.primaryShadow};
  @media (max-width: 991px) {
    box-shadow: none;
  }
`;
const SIDEBAR_IMAGE =
  "https://s3.amazonaws.com/pga.org/employment/jobs/small/small-4.jpg";

const CardBody = styled.div`
  padding: 30px;
  padding-bottom: 0px;
  @media (max-width: 991px) {
    padding: 0px;
  }
`;
export const Card = ({ children }) => (
  <CardContainer>
    <CardBody>{children}</CardBody>
  </CardContainer>
);

export default ({ data }) => {
  const jobInfoList = jobInformationData(data.job);
  const isValidDeadlineDate = isValidDeadline(data.job);
  const isValidPostingStageForApplication = isValidPostingStage(data.job);

  return (
    <SideBarContainer>
      <Card>
        <SideBarContentContainer>
          <OfficeHeader>
            <OfficeImage src={SIDEBAR_IMAGE} />
            <OfficeTitle>{jobOfficeName(data.job)}</OfficeTitle>
          </OfficeHeader>
          <HiddenOn width={991}>
            <ShowApplyButton
              isValidDeadline={isValidDeadlineDate}
              isValidPostingStage={isValidPostingStageForApplication}
              data={data}
              facilityUrl={getFacilityUrl(data)}
            />
          </HiddenOn>
          <SideBarHeader>
            <SideBarHeaderWrapper>
              <SideBarTitle>JOB POSTED BY:</SideBarTitle>
              <SideBarLabel>
                {pathOr("N/A", ["job", "contact", "name"], data)}
              </SideBarLabel>
            </SideBarHeaderWrapper>
          </SideBarHeader>
          <SideBarLabel>
            {pathOr("N/A", ["job", "contact", "title"], data)}
          </SideBarLabel>
        </SideBarContentContainer>
        <JobDetailInfoSection title={"Job Information"} sidebar>
          {jobInfoList.map((item, i) => (
            <JobDetailInfoSectionItem
              key={i}
              title={item.title}
              isLast={jobInfoList.length - 1 === i}
            >
              {item.children}
            </JobDetailInfoSectionItem>
          ))}
        </JobDetailInfoSection>
      </Card>
    </SideBarContainer>
  );
};
